<template>
  <div
    class="progress-bar"
    v-if="$store.state.slide.hasTimeLimit &&
      !$store.state.presentation.audiencePacing &&
      $store.state.presentation.presenting"
  >
    <div class="full-bar">
      <div class="bar-wrapper horizontal layout">
        <div class="bar-default" id="progress-bar-default" />
        <div class="flex">
          <div class="bar-line" id="progress-bar-line" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Config from '@/config'

export default {
  data() {
    return {
      initStartTime: 0,
      previousRemainTime: 0,
    }
  },
  watch: {
    '$store.state.slide.stopSubmission': function (stop) {
      if (!stop) {
        this.initStartTime = 0
        this.previousRemainTime = 0
      }
      this.updateBar()
    },
    '$store.state.slide.stopSubmissionTime': function () {
      this.updateBar()
    },
  },
  mounted() {
    if (!this.$store.state.offsetTime) {
      this.$http.get(Config.api.getTimestamp).then((res) => {
        this.$store.state.offsetTime = new Date().getTime() - res.body.timeStamp
        this.updateBar()
      }).catch(() => {
        this.$store.state.offsetTime = 0
        this.updateBar()
      })
    } else {
      this.updateBar()
    }
  },
  methods: {
    updateBar() {
      const endTime = this.$store.state.slide.stopSubmissionTime
      const { offsetTime } = this.$store.state
      if (!endTime) return

      const timeToAnswer = parseInt(this.$store.state.slide.timeToAnswer, 10)
      const remainTime = endTime - (new Date().getTime() - offsetTime)

      const elmProgessBarDefault = document.getElementById('progress-bar-default')
      const elmProgessBar = document.getElementById('progress-bar-line')

      if (elmProgessBarDefault && elmProgessBar) {
        // Case 1: Stop submission, set to 100%
        if (this.$store.state.slide.stopSubmission) {
          elmProgessBarDefault.style.width = '100%'

        // Case 2: Start slide or refresh, or open submission, start from timeRemain
        } else if (!this.initStartTime) {
          const percentWidth = (timeToAnswer - remainTime / 1000) / timeToAnswer * 100
          elmProgessBarDefault.style.width = `${percentWidth}%`
          this.initStartTime = new Date().getTime()

        // Case 3: Change stopSubmissionTime after running, re-calculate width
        } else {
          const runningTime = new Date().getTime() - this.initStartTime
          const previousWidth = parseFloat(elmProgessBarDefault.style.width)
          const runninngWidth = runningTime / this.previousRemainTime * (100 - previousWidth)
          elmProgessBarDefault.style.width = `${previousWidth + runninngWidth}%`
        }

        elmProgessBar.style.animationDuration = `${remainTime / 1000}s`

        // Change class to reset animation
        if (!elmProgessBar.classList.contains('alternative')) {
          elmProgessBar.classList.add('alternative')
          elmProgessBar.focus()
        } else {
          elmProgessBar.classList.remove('alternative')
          elmProgessBar.focus()
        }
      }

      this.previousRemainTime = remainTime
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.progress-bar {
  padding: 10px 0 10px;
}

.full-bar {
  background-color: #f1f1f1;
  border: 1px solid #fff;
}

.bar-wrapper {
  background: #f1f1f1;
  height: 12px;
}

.bar-line {
  animation-name: progress-bar;
  animation-timing-function: linear;
  background: $primary-color;
  box-sizing: border-box;
  height: 100%;

  &.alternative {
    animation-name: progress-bar-alternative;
  }
}

#progress-bar-default {
  height: 12px;
  background-color: $primary-color;
  width: 0;
}

@keyframes progress-bar {
  from {width: 0%;}
  to {width: 100%;}
}

@keyframes progress-bar-alternative {
  from {width: 0%;}
  to {width: 100%;}
}
</style>
